module.exports = {
    "xd": {
        "cartLevelApproval": {
            "7008190": {
                "idBranch": "7687406387",
                "idAgent": "44c43e07",
                "orders": {
                    "12383275": {
                        "idOrder": 12383275,
                        "idBranch": "7687406387",
                        "idAgent": "44c43e07",
                        "idCart": 7008190,
                        "orderName": "Hello Neighbor",
                        "orderType": "Postcard",
                        "photoCount": 0,
                        "templateName": "Custom (1 Advisor, Team, No HS)",
                        "branchName": "Engel \u0026 V\u00f6lkers Whitefish",
                        "agentName": "Kristi  Bruyer",
                        "usageEmail": "Kristi.Bruyer@engelvoelkers.com",
                        "emailSubject": "Order Approvals for order: Hello Neighbor (#12383275)",
                        "quantity": 200,
                        "subTotal": 170,
                        "dateCreated": "02\/20\/2022",
                        "dateModified": "2022-03-16T11:38:19-05:00",
                        "deliveryType": "mailing",
                        "deliveryService": "Standard",
                        "expeditedProduction": false,
                        "category": {"id": 144613, "name": "Postcards"},
                        "subCategory": {"id": 148414, "name": "Advisor\/Team Face Cards"},
                        "style": {"id": 148434, "name": "Advisor\/Team Face Cards"},
                        "shippingCharge": 0,
                        "salesTax": 0,
                        "appliedPayments": [],
                        "itemThumbnails": ["https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/e543a6db-5632-470d-bb6c-4a533935ae94\/a6aa0305-8441-458d-ac59-bb0e8d4f8512\/0_0[2000x2000].jpg?version=b12a9604-bc5d-4175-83f9-027c1fa699ef", "https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/e543a6db-5632-470d-bb6c-4a533935ae94\/a6aa0305-8441-458d-ac59-bb0e8d4f8512\/1_0[2000x2000].jpg?version=b12a9604-bc5d-4175-83f9-027c1fa699ef"],
                        "unitPrice": 0.8000000000000000444089209850062616169452667236328125,
                        "promoCode": null,
                        "sampleAddress": {
                            "address": "214 2ND ST E, SUITE 101",
                            "address2": "",
                            "name": "KRISTI BRUYER",
                            "name2": "",
                            "city": "WHITEFISH",
                            "state": "MT",
                            "zip": "59937"
                        },
                        "mailingLists": [{
                            "id": "7671583",
                            "name": "Whitefish Stage - Hello Neighbor",
                            "quantity": 200,
                            "type": "radius",
                            "typeId": 2,
                            "requirePurchase": true,
                            "unitPrice": 0.05000000000000000277555756156289135105907917022705078125
                        }],
                        "approverLevel": "",
                        "isFlatRate": 0,
                        "programType": "MAIN",
                        "isAPI": true,
                        "isCcItem": true,
                        "proofEngineType": 0,
                        "orderCorrupt": false
                    }
                },
                "appliedPayments": {
                    "eligibileForBreakConsolidation": false,
                    "appliedPayments": {
                        "creditCards": [{
                            "type": "token",
                            "cardToken": "4n43297",
                            "cardHolderName": "Kristi Dee Bruyer",
                            "amount": 170
                        }]
                    },
                    "eligibleForBreakConsolidation": false
                }
            },
            // "7472915": {
            //     "idBranch": "8b599537ee", "idAgent": "d328e81a71", "orders": {
            //         "13070933": {
            //             "idOrder": 13070933,
            //             "idBranch": "8b599537ee",
            //             "idAgent": "d328e81a71",
            //             "idCart": 7472915,
            //             "orderName": "Brand Card - Standard Stock",
            //             "orderType": "BusCard",
            //             "photoCount": 1,
            //             "templateName": "Brand Card - Standard Stock",
            //             "branchName": "Engel \u0026 V\u00f6lkers Gulf Shores",
            //             "agentName": "Donna  Worley",
            //             "usageEmail": "Donna.Worley@engelvoelkers.com",
            //             "emailSubject": "Order Approvals for order: Brand Card - Standard Stock (#13070933)",
            //             "quantity": 250,
            //             "subTotal": 40,
            //             "dateCreated": "08\/16\/2022",
            //             "dateModified": "2022-08-16T15:53:46-05:00",
            //             "deliveryType": "shipping",
            //             "deliveryService": "FEDEX_GROUND",
            //             "expeditedProduction": false,
            //             "category": {"id": 146031, "name": "Essentials"},
            //             "subCategory": {"id": 146033, "name": "Brand Cards"},
            //             "style": {"id": 146508, "name": "Brand Card"},
            //             "shippingCharge": 5,
            //             "salesTax": 1.600000000000000088817841970012523233890533447265625,
            //             "appliedPayments": [],
            //             "itemThumbnails": ["https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/2d2260be-1b9c-484d-8762-38ade2bb7853\/181759bb-5f6e-4bba-85b4-af92753d88ee\/0_0[2000x2000].jpg?version=bb0cc199-aa9d-4dc1-9fed-255da79d5098", "https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/2d2260be-1b9c-484d-8762-38ade2bb7853\/181759bb-5f6e-4bba-85b4-af92753d88ee\/1_0[2000x2000].jpg?version=bb0cc199-aa9d-4dc1-9fed-255da79d5098"],
            //             "unitPrice": 40,
            //             "promoCode": null,
            //             "sampleAddress": null,
            //             "mailingLists": [],
            //             "approverLevel": "",
            //             "isFlatRate": 1,
            //             "programType": "MAIN",
            //             "isAPI": true,
            //             "isCcItem": true,
            //             "proofEngineType": 0,
            //             "orderCorrupt": false
            //         }
            //     }, "appliedPayments": {
            //         "eligibleForBreakConsolidation": false, "appliedPayments": [], "paymentErrors": [], "shipping": {
            //             "addressId": 1028350,
            //             "serviceLevel": "FEDEX_GROUND",
            //             "shippingAddress": {
            //                 "idCompany": "0f3cc183",
            //                 "idBranch": "8b599537ee",
            //                 "idAgent": null,
            //                 "idPrimary": 1028350,
            //                 "dateCreated": {
            //                     "date": "2022-05-03 10:19:49.000000",
            //                     "timezone_type": 3,
            //                     "timezone": "America\/Chicago"
            //                 },
            //                 "dateModified": {
            //                     "date": "2022-05-03 10:39:47.000000",
            //                     "timezone_type": 3,
            //                     "timezone": "America\/Chicago"
            //                 },
            //                 "idEntity": "8b599537ee",
            //                 "isInternational": false,
            //                 "type": "office",
            //                 "isVisible": true,
            //                 "contactName": "ENGEL \u0026 V\u00f6LKERS GULF SHORES",
            //                 "company": "ENGEL \u0026 VOLKERS",
            //                 "address1": "769 COMMERCE DRIVE",
            //                 "address2": "",
            //                 "city": "GULF SHORES",
            //                 "state": "AL",
            //                 "postalCode": "36542",
            //                 "plus4": null,
            //                 "deliveryPoint": null,
            //                 "checkDigit": null,
            //                 "countryCode": "US",
            //                 "contactPhone": "1-212-234-3100",
            //                 "cassStatus": true,
            //                 "failed": false,
            //                 "errorCode": "",
            //                 "defaultBranch": true
            //             },
            //             "shippingCharge": 5,
            //             "breakConsolidationCharge": 0,
            //             "estimatedDeliveryDate": "2022-08-19 23:59:00",
            //             "estimatedDeliveryMessage": "Between Fri, Aug 19, 2022 and Tue, Aug 23, 2022 by 11:59pm Local Time",
            //             "breakShippingConsolidation": false
            //         }
            //     }
            // }, "7481504": {
            //     "idBranch": "0f72be3ecd",
            //     "idAgent": "65f0dd6be9",
            //     "orders": {
            //         "13087376": {
            //             "idOrder": 13087376,
            //             "idBranch": "0f72be3ecd",
            //             "idAgent": "65f0dd6be9",
            //             "idCart": 7481504,
            //             "orderName": "4 Ph Dream, Home - Vertical (2 Advisor)",
            //             "orderType": "Postcard",
            //             "photoCount": 5,
            //             "templateName": "4 Ph Dream, Home - Vertical (2 Advisor)",
            //             "branchName": "Engel \u0026 V\u00f6lkers Gilbert",
            //             "agentName": "Josiah  Krol",
            //             "usageEmail": "Josiah.Krol@engelvoelkers.com",
            //             "emailSubject": "Order Approvals for order: 4 Ph Dream, Home - Vertical (2 Advisor) (#13087376)",
            //             "quantity": 50,
            //             "subTotal": 34.5,
            //             "dateCreated": "08\/20\/2022",
            //             "dateModified": "2022-08-20T22:12:56-05:00",
            //             "deliveryType": "shipping",
            //             "deliveryService": "GROUND_HOME_DELIVERY",
            //             "expeditedProduction": false,
            //             "category": {"id": 144613, "name": "Postcards"},
            //             "subCategory": {"id": 148032, "name": "Listing Feature"},
            //             "style": {"id": 148280, "name": "New to Market - 4 Photo Fronts"},
            //             "shippingCharge": 0,
            //             "salesTax": 1.9299999999999999378275106209912337362766265869140625,
            //             "appliedPayments": [],
            //             "itemThumbnails": ["https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/154cc636-274b-49f9-92ae-e355480a7eca\/9f1639d9-90e9-4ba9-bde9-e5bc119ca406\/0_0[2000x2000].jpg?version=84bbe4e5-2cf6-4df1-a66f-e0d65d132c8f", "https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/154cc636-274b-49f9-92ae-e355480a7eca\/9f1639d9-90e9-4ba9-bde9-e5bc119ca406\/1_0[2000x2000].jpg?version=84bbe4e5-2cf6-4df1-a66f-e0d65d132c8f"],
            //             "unitPrice": 0.54000000000000003552713678800500929355621337890625,
            //             "promoCode": null,
            //             "sampleAddress": null,
            //             "mailingLists": [],
            //             "approverLevel": "",
            //             "isFlatRate": 0,
            //             "programType": "MAIN",
            //             "isAPI": true,
            //             "isCcItem": true,
            //             "proofEngineType": 0,
            //             "orderCorrupt": false
            //         }
            //     },
            //     "appliedPayments": {
            //         "appliedPayments": {
            //             "creditCards": [{
            //                 "type": "token",
            //                 "cardToken": "fn2njtv",
            //                 "cardHolderName": "Josiah Krol",
            //                 "cardLast4": "8817",
            //                 "amount": 36.42999999999999971578290569595992565155029296875
            //             }]
            //         }, "paymentErrors": []
            //     }
            // }, "7257981": {
            //     "idBranch": "ea3d4e6b8c",
            //     "idAgent": "ff808c12ad",
            //     "orders": {
            //         "13118536": {
            //             "idOrder": 13118536,
            //             "idBranch": "ea3d4e6b8c",
            //             "idAgent": "ff808c12ad",
            //             "idCart": 7257981,
            //             "orderName": "Personalized Approach (2 Advisor)",
            //             "orderType": "Postcard",
            //             "photoCount": 3,
            //             "templateName": "Personalized Approach (2 Advisor)",
            //             "branchName": "Engel \u0026 V\u00f6lkers Delray Beach",
            //             "agentName": "Cindy  Giandomenico",
            //             "usageEmail": "Cindy.Giandomenico@engelvoelkers.com",
            //             "emailSubject": "Order Approvals for order: Personalized Approach (2 Advisor) (#13118536)",
            //             "quantity": 415,
            //             "subTotal": 340.30000000000001136868377216160297393798828125,
            //             "dateCreated": "08\/30\/2022",
            //             "dateModified": "2022-09-08T12:49:35-05:00",
            //             "deliveryType": "mailing",
            //             "deliveryService": "Standard",
            //             "expeditedProduction": false,
            //             "category": {"id": 144613, "name": "Postcards"},
            //             "subCategory": {"id": 148414, "name": "Advisor\/Team Face Cards"},
            //             "style": {"id": 148434, "name": "Advisor\/Team Face Cards"},
            //             "shippingCharge": 0,
            //             "salesTax": 11.449999999999999289457264239899814128875732421875,
            //             "appliedPayments": [],
            //             "itemThumbnails": ["https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/c7fca1f4-9b93-4049-aa04-ddd75f28bbe2\/64d4e954-fc42-4248-9828-763d6705bc53\/0_0[2000x2000].jpg?version=16d9288c-3e36-45d6-a689-93bf9a856c42", "https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/c7fca1f4-9b93-4049-aa04-ddd75f28bbe2\/64d4e954-fc42-4248-9828-763d6705bc53\/1_0[2000x2000].jpg?version=16d9288c-3e36-45d6-a689-93bf9a856c42"],
            //             "unitPrice": 0.81999999999999995115018691649311222136020660400390625,
            //             "promoCode": null,
            //             "sampleAddress": {
            //                 "address": "900 EAST ATLANTIC AVENUE SUITE 14",
            //                 "address2": "",
            //                 "name": "CINDY GIANDOMENICO",
            //                 "name2": "",
            //                 "city": "DELRAY BEACH",
            //                 "state": "FL",
            //                 "zip": "33483"
            //             },
            //             "mailingLists": [{
            //                 "id": "7934308",
            //                 "name": "Cindy Giandomenico - 2022-09-08",
            //                 "quantity": 415,
            //                 "type": "upload",
            //                 "typeId": 1,
            //                 "requirePurchase": false,
            //                 "unitPrice": 0
            //             }],
            //             "approverLevel": "",
            //             "isFlatRate": 0,
            //             "programType": "MAIN",
            //             "isAPI": true,
            //             "isCcItem": true,
            //             "proofEngineType": 0,
            //             "orderCorrupt": false
            //         }
            //     },
            //     "appliedPayments": {
            //         "eligibleForBreakConsolidation": true,
            //         "appliedPayments": {
            //             "creditCards": [{
            //                 "type": "token",
            //                 "cardToken": "fb8f7bwg",
            //                 "cardHolderName": "Cynthia Giandomenico",
            //                 "cardLast4": "1000",
            //                 "amount": 351.75
            //             }]
            //         }
            //     }
            // }, "7530205": {
            //     "idBranch": "330be5f457", "idAgent": "ee037a9a77", "orders": {
            //         "13176128": {
            //             "idOrder": 13176128,
            //             "idBranch": "330be5f457",
            //             "idAgent": "ee037a9a77",
            //             "idCart": 7530205,
            //             "orderName": "1 Ph Custom - Option 1 (1 Advisor, Team, No HS)",
            //             "orderType": "Postcard",
            //             "photoCount": 2,
            //             "templateName": "1 Ph Custom - Option 1 (1 Advisor, Team, No HS)",
            //             "branchName": "Engel \u0026 V\u00f6lkers Tremblant",
            //             "agentName": "Louis  Gigu\u00e8re",
            //             "usageEmail": "Louis.Giguere@engelvoelkers.com",
            //             "emailSubject": "Order Approvals for order: 1 Ph Custom - Option 1 (1 Advisor, Team, No HS) (#13176128)",
            //             "quantity": 1200,
            //             "subTotal": 480,
            //             "dateCreated": "09\/14\/2022",
            //             "dateModified": "2022-09-15T11:01:15-05:00",
            //             "deliveryType": "shipping",
            //             "deliveryService": "INTERNATIONAL_ECONOMY",
            //             "expeditedProduction": false,
            //             "category": {"id": 144613, "name": "Postcards"},
            //             "subCategory": {"id": 148032, "name": "Listing Feature"},
            //             "style": {"id": 148033, "name": "New to Market - 1 Photo Fronts"},
            //             "shippingCharge": 0,
            //             "salesTax": 0,
            //             "appliedPayments": [],
            //             "itemThumbnails": ["https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/89806d3d-b850-4794-9ba1-f003f98bcd42\/1e7a6ff9-d7b4-490c-931a-b16f693d3abe\/0_0[2000x2000].jpg?version=8dcf8597-ec3f-4802-a8ba-47274a897592", "https:\/\/ds.xpressdocs.com\/api\/rendering\/GetProofImage\/89806d3d-b850-4794-9ba1-f003f98bcd42\/1e7a6ff9-d7b4-490c-931a-b16f693d3abe\/1_0[2000x2000].jpg?version=8dcf8597-ec3f-4802-a8ba-47274a897592"],
            //             "unitPrice": 0.40000000000000002220446049250313080847263336181640625,
            //             "promoCode": null,
            //             "sampleAddress": null,
            //             "mailingLists": [],
            //             "approverLevel": "",
            //             "isFlatRate": 0,
            //             "programType": "MAIN",
            //             "isAPI": true,
            //             "isCcItem": true,
            //             "proofEngineType": 0,
            //             "orderCorrupt": false
            //         }
            //     }, "appliedPayments": {
            //         "eligibleForBreakConsolidation": false,
            //         "shipping": {
            //             "addressId": 923500,
            //             "serviceLevel": "INTERNATIONAL_ECONOMY",
            //             "shippingAddress": {
            //                 "idCompany": "0f3cc183",
            //                 "idBranch": "330be5f457",
            //                 "idAgent": "ee037a9a77",
            //                 "idPrimary": 923500,
            //                 "dateCreated": {
            //                     "date": "2021-03-05 15:02:23.000000",
            //                     "timezone_type": 3,
            //                     "timezone": "America\/Chicago"
            //                 },
            //                 "dateModified": {
            //                     "date": "2021-03-05 15:02:23.000000",
            //                     "timezone_type": 3,
            //                     "timezone": "America\/Chicago"
            //                 },
            //                 "idEntity": "ee037a9a77",
            //                 "isInternational": true,
            //                 "type": "residential",
            //                 "isVisible": true,
            //                 "contactName": "LOUIS GIGU\u00c8RE",
            //                 "company": "",
            //                 "address1": "290",
            //                 "address2": "RUE DE ST-MORITZ",
            //                 "city": "STE-AD\u00e8LE",
            //                 "state": "QC",
            //                 "postalCode": "J8B2Z6",
            //                 "plus4": null,
            //                 "deliveryPoint": null,
            //                 "checkDigit": null,
            //                 "countryCode": "CA",
            //                 "contactPhone": "514-594-9527",
            //                 "cassStatus": false,
            //                 "failed": false,
            //                 "errorCode": null,
            //                 "defaultBranch": false,
            //                 "country": "Canada"
            //             },
            //             "shippingCharge": 13,
            //             "breakConsolidationCharge": 0,
            //             "estimatedDeliveryDate": "2022-09-19 20:00:00",
            //             "estimatedDeliveryMessage": "Monday, Sep 19, 2022 by 8:00pm Local Time",
            //             "breakShippingConsolidation": false
            //         },
            //         "appliedPayments": {
            //             "creditCards": [{
            //                 "type": "token",
            //                 "cardToken": "2sgnn3x",
            //                 "cardHolderName": "LOUIS GIGU\u00c8RE",
            //                 "cardLast4": "0393",
            //                 "amount": 493
            //             }]
            //         }
            //     }
            // }
        }
    }, "procurement": [], "oci": []
};